import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";

import { AutoComplete, Input, Select } from "antd";
import Loading from "../../../Components/Loading/Loading";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import CustomModal from "../../../Components/Customs/CustomModal";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";
import { GoPlusCircle } from "react-icons/go";
import Drivers from "../YukXatiAdd/Drivers";
import { IoIosAdd } from "react-icons/io";
const searchResult = (query) => {
  return query.map((el, idx) => {
    return {
      value: `${el.id}. ${el.name}  INN:${el.INN}  TEL:${el.phone}`,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{el.name}</span>
          <span>inn:{el.INN}</span>
          <span>{el.phone}</span>
        </div>
      ),
    };
  });
};

const searchResultSriver = (query) => {
  console.log(query);
  return query.map((el, idx) => {
    return {
      value: `${el.id}.  N:${el.auto_number}:  Shaf:${el.driver_name}:  PNFL:${el.PNFL}:`,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>N:{el.auto_number}</span>
          <span>Shaf:{el.driver_name}</span>
          <span>PNFL:{el.PNFL}</span>
        </div>
      ),
    };
  });
};

export default function AddYukXatiKirim() {
  const [checked, setChecked] = React.useState("notChecked");
  const [info, setInfo] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(null);

  const [loading, setLoading] = React.useState(false);
  let [data, setData] = useState({
    auto: null,
    driver_name: null,
  });
  let [selected, setSelected] = useState(null);
  let [vagon, setVagon] = useState(null);
  let [openModal, setOpenModal] = useState(false);
  let [errorMsg, setErrorMsg] = useState(null);
  let [names, setNames] = useState(false);
  let [focused, setFocused] = useState(false);
  const messageApi = useMessage();
  const [options, setOptions] = useState([]);
  let navigate = useNavigate();

  let [products, setProducts] = useState({
    tonna: "",
    where_to: "",
    name: "",
    price_qop: "",
  });

  const elementRef = React.useRef(null);
  const [drivers, setDrivers] = useState(null);

  let searchDriver = async (val) => {
    try {
      setLoading(true);

      let { data: driver } = await axiosInstance.get(
        "/api/drivers/search?search=" + val
      );

      if (driver.success) {
        console.log(driver);
        setDrivers(driver.data);
        setOptions(val ? searchResultSriver(driver?.data) : []);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleAdd = async (values) => {
    try {
      setLoading(true);
      let res = await axiosInstance.post("/api/kirim", {
        ...values,
      });
      console.log(res.data);

      if (res.data.success) {
        messageApi.open({
          type: "success",
          content: "Mahsulot Qo'shildi :)",
        });
        navigate("/yukxati/kirim");
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const getNames = async () => {
    try {
      setLoading(true);
      // /api/drivers
      let info = await axiosInstance.get("/api/add-product");

      if (info.data.success) {
        setNames(info.data.data);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNames();
  }, []);

  // const [options, setOptions] = useState([]);
  const [addOption, setAddOption] = useState("");
  const onSelect_auto = (value) => {
    setSelected(value);

    let infos = value.split(":").filter((el, i) => {
      if (i !== 0 && i % 2 !== 0) {
        return el;
      }
    });

    console.log(value);
    setData({
      ...data,
      driver_name: infos[1],
      auto_number: infos[0],
      PNFL: infos[2],
    });
  };

  const handleSearch = async (value) => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get(
        "/api/customers/search?search=" + value
      );
      console.log(data);
      setSelected(data?.data);
      setOptions(value ? searchResult(data?.data) : []);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const onSelect = (value) => {
    setSelected(value);

    console.log(value.split(".")[0]);
    console.log(value);
    setData({
      customer_id: Number(value.split(".")[0]),
      ...data,
    });
    setChecked("valid");
  };

  return (
    <div className="max-w-[900px] w-[98%] m-auto mb-[40px] pb-[100px]">
      <div className="flex items-center justify-between">
        <button
          className="p-4"
          onClick={() => {
            navigate("/yukxati/kirim");
          }}
        >
          <ClearOutlinedIcon />
        </button>
        <Button variant="solid" icon={<GoPlusCircle className="font-[30px]" />}>
          Yangi Kirim
        </Button>
      </div>

      <div>
        <div className="flex flex-col md:flex-row flex-wrap items-center justify-start gap-[10px] w-[100%]">
          <div className="bg-[#fff] p-4 shadow my-2 rounded w-[100%]">
            <div class="w-[100%]">
              <label
                for="options"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                Dori tanlang
              </label>
              <div class="relative">
                <select
                  id="options"
                  onChange={(e) => {
                    setProducts({
                      ...products,
                      name: e.target.value,
                    });
                  }}
                  class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                >
                  <option value="">Dori turi</option>
                  {names
                    ? names.map((el) => {
                        return <option value={el.name}>{el.name}</option>;
                      })
                    : null}
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M7 10l5 5 5-5H7z" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-[100%] gap-1 justify-between">
              <div class=" w-[100%] md:w-[50%]">
                <label
                  for="input-with-helper-text"
                  class="block text-sm font-medium text-gray-700"
                >
                  Necha tonna ({(products.tonna * 1000) / 50} qop)
                </label>
                <input
                  type="text"
                  onChange={(e) => {
                    console.log(e.target.value);
                    setProducts({
                      ...products,
                      tonna: e.target.value,
                    });
                  }}
                  value={products.tonna}
                  id="input-with-helper-text"
                  class="w-[100%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="Necha tonna"
                />
              </div>

              <div class="w-[100%] md:w-[50%]">
                <label
                  for="options"
                  class="block text-sm font-medium text-gray-700 mb-1"
                >
                  Qayerdan
                </label>
                <div class="relative">
                  <select
                    id="options"
                    onChange={(e) => {
                      setProducts({
                        ...products,
                        where_to: e.target.value,
                      });
                    }}
                    class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                  >
                    <option value="">Qayerdan</option>
                    <option value="Paxta zavod">Paxta zavod</option>
                    <option value="Ko'mirxona">Ko'mirxona</option>
                    <option value="Vagon">Molxona</option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M7 10l5 5 5-5H7z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class=" w-[100%] md:w-[100%]">
              <label
                for="input-with-helper-text"
                class="block text-sm font-medium text-gray-700"
              >
                Qop Narxi
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setProducts({
                    ...products,
                    price_qop: e.target.value,
                  });
                }}
                value={products.price_qop}
                id="input-with-helper-text"
                class="w-[100%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                placeholder="Qop Narxi"
              />
            </div>
          </div>
        </div>
        <div className="w-[100%]">
          <AutoComplete
            popupMatchSelectWidth={"100px"}
            style={{
              width: "100%",
            }}
            className="max-w-[900px]"
            options={options}
            onSelect={onSelect}
            onSearch={handleSearch}
            size="large"
          >
            <Input.Search
              loading={loading}
              size="large"
              placeholder="Qidirish..."
              enterButton
            />
          </AutoComplete>
        </div>
        {/* main form */}
        <div className="relative my-4">
          <label htmlFor="driver_name">Auto raqam</label>{" "}
          <Drivers setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
          <div className="flex flex-row gap-1">
            <AutoComplete
              popupMatchSelectWidth={"100px"}
              style={{
                width: "100%",
              }}
              className="max-w-[900px]"
              options={options}
              onSelect={onSelect_auto}
              onSearch={searchDriver}
              size="large"
            >
              <Input.Search
                // loading={loadingCustomer}
                size="large"
                placeholder="Qidirish..."
                enterButton
              />
            </AutoComplete>
            <Button
              variant="outlined"
              className="w-[50px] "
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <IoIosAdd />
            </Button>
          </div>
        </div>

        <label htmlFor="driver_name">Shafyor ismi</label>
        <Input
          loading={loading}
          size="large"
          placeholder="Auto raqam..."
          enterButton
          value={data.driver_name}
          onChange={(e) => {
            setData({
              ...data,
              driver_name: e.target.value,
            });
            // console.log(e.target.value);
          }}
        />
        <Formik
          initialValues={{
            date: "",
            comment: "",
          }}
          validationSchema={Yup.object({
            date: Yup.string().required("Yozish shart"),
            auto: Yup.string(),
            driver_name: Yup.string(),
            comment: Yup.string(),
          })}
          onSubmit={(values) => {
            handleAdd({
              ...values,
              ...data,
              ...products,
              tonna: Number(products.tonna),
            });
          }}
        >
          <Form>
            <br />
            <label htmlFor="date">Sana</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="date"
              type="date"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="date" />
            </div>
            <br />

            {/* comment */}
            <label htmlFor="comment">Izox</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="comment"
              as="textarea"
              rows="4"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="comment" />
            </div>
            <br />
            <br />
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block w-full"
            >
              Qo'shish
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
}
